import { render, staticRenderFns } from "./CandidateTemplate.vue?vue&type=template&id=2d6b0db3&"
import script from "./CandidateTemplate.vue?vue&type=script&lang=js&"
export * from "./CandidateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CandidateTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports